/**
 * Pure helpers for Cognito password reset (forgot password) flow.
 */

export function normalizeUsername(email) {
  return typeof email === 'string' ? email.trim().toLowerCase() : '';
}

/**
 * Validates fields before confirmResetPassword.
 * @returns {{ ok: true } | { ok: false, error: string }}
 */
export function validateResetConfirmFields({ confirmationCode, password, confirmPassword }) {
  const code = typeof confirmationCode === 'string' ? confirmationCode.trim() : '';
  if (!code) {
    return { ok: false, error: 'Enter the verification code from your email.' };
  }
  if (!password) {
    return { ok: false, error: 'Enter a new password.' };
  }
  if (password !== confirmPassword) {
    return { ok: false, error: 'Passwords do not match.' };
  }
  return { ok: true };
}
